/* tslint:disable */
/* eslint-disable */
/**
 * crm-phone-agent
 * crm-phone-agent
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type CreateCallExecution200Response,
    CreateCallExecution200ResponseFromJSON,
    CreateCallExecution200ResponseToJSON,
} from '../models/CreateCallExecution200Response';
import {
    type CreateCallExecutionRequest,
    CreateCallExecutionRequestFromJSON,
    CreateCallExecutionRequestToJSON,
} from '../models/CreateCallExecutionRequest';
import {
    type FindAllCallExecutions200Response,
    FindAllCallExecutions200ResponseFromJSON,
    FindAllCallExecutions200ResponseToJSON,
} from '../models/FindAllCallExecutions200Response';
import {
    type FindCallExecutionById200Response,
    FindCallExecutionById200ResponseFromJSON,
    FindCallExecutionById200ResponseToJSON,
} from '../models/FindCallExecutionById200Response';
import {
    type GetPayorConfigForFacility200Response,
    GetPayorConfigForFacility200ResponseFromJSON,
    GetPayorConfigForFacility200ResponseToJSON,
} from '../models/GetPayorConfigForFacility200Response';

export interface CreateCallExecutionOperationRequest {
    /**
     * Lead ID
     */
    leadId: string;
    /**
     * 
     */
    createCallExecutionRequest: CreateCallExecutionRequest;
}

export interface FindAllCallExecutionsRequest {
    /**
     * Lead ID
     */
    leadId: string;
}

export interface FindCallExecutionByIdRequest {
    /**
     * Lead ID
     */
    leadId: string;
    /**
     * Call execution ID
     */
    callExecutionId: string;
}

export interface GetPayorConfigForFacilityRequest {
    /**
     * Facility ID
     */
    facilityId: string;
}

export interface RetryCallAnalysisRequest {
    /**
     * Lead ID
     */
    leadId: string;
    /**
     * Call execution ID
     */
    callExecutionId: string;
}

export interface RetryCallExecutionRequest {
    /**
     * Lead ID
     */
    leadId: string;
    /**
     * Call execution ID
     */
    callExecutionId: string;
}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI {

    /**
     * Creates request options for createCallExecution without sending the request
     */
    async createCallExecutionRequestOpts(requestParameters: CreateCallExecutionOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling createCallExecution().'
            );
        }

        if (requestParameters['createCallExecutionRequest'] == null) {
            throw new runtime.RequiredError(
                'createCallExecutionRequest',
                'Required parameter "createCallExecutionRequest" was null or undefined when calling createCallExecution().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/{lead_id}/call-executions`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateCallExecutionRequestToJSON(requestParameters['createCallExecutionRequest']),
        };
    }

    /**
     * Create a new call execution
     */
    async createCallExecutionRaw(requestParameters: CreateCallExecutionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateCallExecution200Response>> {
        const requestOptions = await this.createCallExecutionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateCallExecution200ResponseFromJSON(jsonValue));
    }

    /**
     * Create a new call execution
     */
    async createCallExecution(requestParameters: CreateCallExecutionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateCallExecution200Response> {
        const response = await this.createCallExecutionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findAllCallExecutions without sending the request
     */
    async findAllCallExecutionsRequestOpts(requestParameters: FindAllCallExecutionsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling findAllCallExecutions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/{lead_id}/call-executions`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * List all call executions for a lead
     */
    async findAllCallExecutionsRaw(requestParameters: FindAllCallExecutionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllCallExecutions200Response>> {
        const requestOptions = await this.findAllCallExecutionsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllCallExecutions200ResponseFromJSON(jsonValue));
    }

    /**
     * List all call executions for a lead
     */
    async findAllCallExecutions(requestParameters: FindAllCallExecutionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllCallExecutions200Response> {
        const response = await this.findAllCallExecutionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findCallExecutionById without sending the request
     */
    async findCallExecutionByIdRequestOpts(requestParameters: FindCallExecutionByIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling findCallExecutionById().'
            );
        }

        if (requestParameters['callExecutionId'] == null) {
            throw new runtime.RequiredError(
                'callExecutionId',
                'Required parameter "callExecutionId" was null or undefined when calling findCallExecutionById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/{lead_id}/call-executions/{call_execution_id}`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));
        urlPath = urlPath.replace('{call_execution_id}', encodeURIComponent(String(requestParameters['callExecutionId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get a call execution record
     */
    async findCallExecutionByIdRaw(requestParameters: FindCallExecutionByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindCallExecutionById200Response>> {
        const requestOptions = await this.findCallExecutionByIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindCallExecutionById200ResponseFromJSON(jsonValue));
    }

    /**
     * Get a call execution record
     */
    async findCallExecutionById(requestParameters: FindCallExecutionByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindCallExecutionById200Response> {
        const response = await this.findCallExecutionByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getPayorConfigForFacility without sending the request
     */
    async getPayorConfigForFacilityRequestOpts(requestParameters: GetPayorConfigForFacilityRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError(
                'facilityId',
                'Required parameter "facilityId" was null or undefined when calling getPayorConfigForFacility().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/payor-config/{facility_id}`;
        urlPath = urlPath.replace('{facility_id}', encodeURIComponent(String(requestParameters['facilityId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get enabled payor configuration for a facility
     */
    async getPayorConfigForFacilityRaw(requestParameters: GetPayorConfigForFacilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPayorConfigForFacility200Response>> {
        const requestOptions = await this.getPayorConfigForFacilityRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPayorConfigForFacility200ResponseFromJSON(jsonValue));
    }

    /**
     * Get enabled payor configuration for a facility
     */
    async getPayorConfigForFacility(requestParameters: GetPayorConfigForFacilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPayorConfigForFacility200Response> {
        const response = await this.getPayorConfigForFacilityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for retryCallAnalysis without sending the request
     */
    async retryCallAnalysisRequestOpts(requestParameters: RetryCallAnalysisRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling retryCallAnalysis().'
            );
        }

        if (requestParameters['callExecutionId'] == null) {
            throw new runtime.RequiredError(
                'callExecutionId',
                'Required parameter "callExecutionId" was null or undefined when calling retryCallAnalysis().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/{lead_id}/call-executions/{call_execution_id}/retry-analysis`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));
        urlPath = urlPath.replace('{call_execution_id}', encodeURIComponent(String(requestParameters['callExecutionId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Re-analyze a call execution transcript which failed to process
     */
    async retryCallAnalysisRaw(requestParameters: RetryCallAnalysisRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.retryCallAnalysisRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Re-analyze a call execution transcript which failed to process
     */
    async retryCallAnalysis(requestParameters: RetryCallAnalysisRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.retryCallAnalysisRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for retryCallExecution without sending the request
     */
    async retryCallExecutionRequestOpts(requestParameters: RetryCallExecutionRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling retryCallExecution().'
            );
        }

        if (requestParameters['callExecutionId'] == null) {
            throw new runtime.RequiredError(
                'callExecutionId',
                'Required parameter "callExecutionId" was null or undefined when calling retryCallExecution().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/{lead_id}/call-executions/{call_execution_id}/retry`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));
        urlPath = urlPath.replace('{call_execution_id}', encodeURIComponent(String(requestParameters['callExecutionId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Retry an existing call execution
     */
    async retryCallExecutionRaw(requestParameters: RetryCallExecutionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateCallExecution200Response>> {
        const requestOptions = await this.retryCallExecutionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateCallExecution200ResponseFromJSON(jsonValue));
    }

    /**
     * Retry an existing call execution
     */
    async retryCallExecution(requestParameters: RetryCallExecutionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateCallExecution200Response> {
        const response = await this.retryCallExecutionRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
